export const ArrowIconWrapper =
  'flex cursor-pointer focus:outline-none active:outline-none max-w-[60px] px-4'

export const IndicatorWrapper =
  'flex h-full w-fit items-center justify-center text-black leading-24 pointer-events-none select-none'

export const RecommendationCarouselWrapper =
  'flex flex-col w-full overflow-hidden'

export const RecommendationCarouselTilesWrapper =
  'flex w-full transition-transform duration-700'

export const RecommendationCarouselControlsWrapper =
  'flex h-[60px] w-full items-center justify-center px-8 select-none'
